import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

import styles from "./RegistrationPage.module.css";
import { db } from "../../services/firebaseConfig";
import Button from "../../components/common/Button";
import { Input } from "../../components/common/Input";
import InputArea from "../../components/common/InputArea";

export default function RegistrationPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    profession: "",
    bio: "",
    linkedin: "",
    message: "",
    website: "", // honeypot (deve ficar invisible)
  });
  const [status, setStatus] = useState(null);

  const onChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const validate = () => {
    if (!form.name.trim() || !form.email.trim() || !form.profession.trim())
      return "Preencha nome, email e profissão.";
    // email simples
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(form.email)) return "Email inválido.";
    if (form.website) return "Spam detectado."; // honeypot
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) {
      setStatus({ kind: "error", text: err });
      return;
    }
    setStatus({ kind: "saving", text: "Enviando..." });
    try {
      await addDoc(collection(db, "registrations"), {
        name: form.name.trim(),
        email: form.email.trim().toLowerCase(),
        profession: form.profession.trim(),
        bio: form.bio.trim(),
        linkedin: form.linkedin.trim(),
        message: form.message.trim(),
        status: "pending",
        source: "circulo-pratica",
        createdAt: serverTimestamp(),
      });
      setStatus({
        kind: "success",
        text: "Recebemos sua inscrição. Você receberá um e-mail em breve.",
      });
      setForm({
        name: "",
        email: "",
        profession: "",
        bio: "",
        linkedin: "",
        message: "",
        website: "",
      });
    } catch (error) {
      console.error("Registration error", error);
      setStatus({ kind: "error", text: "Erro ao enviar, tente novamente." });
    }
  };

  return (
    <section className={styles.page}>
      <div>
        <div className={styles.header}>
          <h1>Inscrição</h1>
          <h1>Grupo de Discussão em Terapia Baseada em Processos</h1>
        </div>
        <div className={styles.subtitle}>
          <p>
            Inscreva-se para participar dos encontros de discussão de casos com
            foco na Terapia Baseada em Processos (PBT) e Terapia de Aceitação e
            Compromisso (ACT).
          </p>
          <p>
            A participação é gratuita. Os encontros ocorrem a cada 15 dias,
            quarta-feira às 19 horas.
          </p>
          {/* <p>
            Próximo encontro: XXXXX
          </p> */}
        </div>
        <form
          onSubmit={handleSubmit}
          style={
            status
              ? { display: "grid", gap: 12 }
              : { display: "grid", gap: 12, marginBottom: "5rem" }
          }
        >
          <Input
            name="name"
            label="Nome completo"
            value={form.name}
            onChange={onChange}
          />
          <Input
            name="email"
            label="Email profissional"
            value={form.email}
            onChange={onChange}
          />
          <Input
            name="profession"
            label="Profissão / Formação"
            value={form.profession}
            onChange={onChange}
          />
          <Input
            name="linkedin"
            label="LinkedIn (opcional)"
            value={form.linkedin}
            onChange={onChange}
          />
          <InputArea
            name="bio"
            label="Uma linha sobre você (ex: experiência com ACT)"
            value={form.bio}
            onChange={onChange}
          />
          <InputArea
            name="message"
            label="Por que quer participar? (opcional)"
            value={form.message}
            onChange={onChange}
          />

          {/* HONEYPOT - deixe este input escondido via styles; bots costumam preencher */}
          <input
            name="website"
            value={form.website}
            onChange={onChange}
            style={{ display: "none" }}
            tabIndex="-1"
            autoComplete="off"
          />

          <div>
            <Button type="submit">Inscrever-se</Button>
          </div>
        </form>

        {status && (
          <div
            style={{
              marginTop: 12,
              color: status.kind === "error" ? "crimson" : "green",
              marginBottom: "5rem",
            }}
          >
            {status.text}
          </div>
        )}

        {/* <small style={{ display: "block", marginTop: 12 }}>
          Dica: para reduzir spam ative reCAPTCHA (consulte a documentação na
          sua implementação).
        </small> */}
      </div>
    </section>
  );
}
